import React, { useState, useEffect } from "react";
import { Backdrop, CircularProgress, Button } from "@mui/material";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AADHeader from "./components/AADHeader.js";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Link from "@mui/material/Link";
import { MdRefresh } from "react-icons/md";
import { AutoComplete } from "primereact/autocomplete";
import { Dropdown } from "primereact/dropdown";
import { DatePicker } from "antd";
import { BiSolidCalendar } from "react-icons/bi";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";

const ReportHistory1 = () => {
  const navigate = useNavigate();

  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [loading, setLoading] = useState(false);
  const initialFormData = {
    siteLocation: "",
    esgParameter: "",
    topic: "",
    subtopic: "",
  };

  const initialFilters = {
    siteLocation: { value: null, matchMode: FilterMatchMode.CONTAINS },
    startDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    endDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    transmissionMode: { value: null, matchMode: FilterMatchMode.CONTAINS },
    energySource: { value: null, matchMode: FilterMatchMode.CONTAINS },
    contractInstrumentType: { value: null, matchMode: FilterMatchMode.CONTAINS },
    supplier: { value: null, matchMode: FilterMatchMode.CONTAINS },
    electricityConsumption: { value: null, matchMode: FilterMatchMode.CONTAINS },
    emissionFactorType: { value: null, matchMode: FilterMatchMode.CONTAINS },
    emissionsFactor: { value: null, matchMode: FilterMatchMode.CONTAINS },
    locationEmissions: { value: null, matchMode: FilterMatchMode.CONTAINS },
    marketEmissions: { value: null, matchMode: FilterMatchMode.CONTAINS },
    unitCost: { value: null, matchMode: FilterMatchMode.CONTAINS },
    owner: { value: null, matchMode: FilterMatchMode.CONTAINS },
    reportPeriod: { value: null, matchMode: FilterMatchMode.CONTAINS },
    latestRefresh: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  // for the two dropdowns
  const [formData, setFormData] = useState(initialFormData);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [supplier, setSupplier] = useState(null);
  const [owner, setOwner] = useState(null);
  const [filters, setFilters] = useState(initialFilters);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [ownerOptions, setOwnerOptions] = useState([]);
  // per-column filter definitions

  const handleResetFilters = () => {
    setFormData(initialFormData);
    setFromDate(null);
    setToDate(null);
    setSupplier(null);
    setOwner(null);
    setFilters(initialFilters);
  };

  // dummy table data
  const [tableData, setTableData] = useState([
    {
      siteLocation: "New York",
      startDate: "2025-05-01",
      endDate: "2025-05-31",
      transmissionMode: "Grid",
      energySource: "Solar",
      contractInstrumentType: "PPA",
      supplier: "Acme Energy",
      electricityConsumption: 123.4,
      emissionFactorType: "Scope 2",
      emissionsFactor: 0.45,
      locationEmissions: 55.53,
      marketEmissions: 60.21,
      unitCost: 75.0,
      owner: "John Doe",
      reportPeriod: "May 2025",
      latestRefresh: "2025-06-01",
    },
    {
      siteLocation: "London",
      startDate: "2025-04-01",
      endDate: "2025-04-30",
      transmissionMode: "Wind Farm",
      energySource: "Wind",
      contractInstrumentType: "Market",
      supplier: "GreenPower",
      electricityConsumption: 98.7,
      emissionFactorType: "Scope 2",
      emissionsFactor: 0.4,
      locationEmissions: 39.48,
      marketEmissions: 42.15,
      unitCost: 65.5,
      owner: "Jane Smith",
      reportPeriod: "April 2025",
      latestRefresh: "2025-05-02",
    },
    // add more dummy rows as needed
  ]);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true); // Open sidebar on larger screens
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };

  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="page-content-wrapper" className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}>
        <div className="container formpd report-history">
          <div className="flex justify-content-between">
            <div className="steps__containt-hader">
              <h1 className="title">Scope 2 Report History</h1>
              <div role="presentation">
                <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                  <Link underline="hover" color="inherit" href="/newconfig">
                    Configuration
                  </Link>
                  <Typography color="text.primary">Report History</Typography>
                </Breadcrumbs>
              </div>
            </div>
            <div className="steps__containt-hader">
              <div className="col-auto">
                <Button className="refresh-cta" variant="text" startIcon={<MdRefresh />} onClick={handleResetFilters}>
                  Reset Filters
                </Button>
              </div>
            </div>
          </div>
          <div className="form-part">
            <form>
              <div className="row g-3 mb-2 autopopulate-row">
                <div className="form-group col-md-3">
                  <label className="formlable">Site Location</label>
                  <input type="text" className="form-control" id="siteLocation" placeholder="Autopopulate" disabled value={formData.siteLocation} onChange={(e) => setFormData({ ...formData, siteLocation: e.target.value })} />
                </div>
                <div className="form-group col-md-3">
                  <label className="formlable">ESG Parameter</label>
                  <input type="text" className="form-control" id="esgParameter" placeholder="Autopopulate" disabled value={formData.esgParameter} onChange={(e) => setFormData({ ...formData, esgParameter: e.target.value })} />
                </div>
                <div className="form-group col-md-3">
                  <label className="formlable">Topic</label>
                  <input type="text" className="form-control" id="topic" placeholder="Autopopulate" disabled value={formData.topic} onChange={(e) => setFormData({ ...formData, topic: e.target.value })} />
                </div>
                <div className="form-group col-md-3">
                  <label className="formlable">Subtopic</label>
                  <input type="text" className="form-control" id="subtopic" placeholder="Autopopulate" disabled value={formData.subtopic} onChange={(e) => setFormData({ ...formData, subtopic: e.target.value })} />
                </div>
              </div>

              {/* ───── Second row: Dates + 2 Dropdowns ───── */}
              <div className="row g-3 mb-4">
                <div className="form-group col-md-3">
                  <DatePicker
                    value={fromDate}
                    onChange={(date) => {
                      setFromDate(date);
                      if (!date) setToDate(null);
                    }}
                    popupClassName="scf-custom-date"
                    className="form-control calendar-form"
                    placeholder="Start Date"
                    format="YYYY-MM-DD"
                    suffixIcon={<BiSolidCalendar />}
                    showToday={false}
                  />
                </div>
                <div className="form-group col-md-3">
                  <DatePicker value={toDate} onChange={(date) => setToDate(date)} popupClassName="scf-custom-date" className="form-control calendar-form" placeholder="End Date" format="YYYY-MM-DD" suffixIcon={<BiSolidCalendar />} showToday={false} disabled={!fromDate} disabledDate={(current) => current && current < fromDate} />
                </div>
                <div className="form-group col-md-3">
                  <Dropdown options={supplierOptions} value={supplier} onChange={(e) => setSupplier(e.value)} placeholder="Supplier" className="p-inputtext-sm wd-100" style={{ height: "40px !important" }} filter />
                </div>
                <div className="form-group col-md-3">
                  <Dropdown options={ownerOptions} value={owner} onChange={(e) => setOwner(e.value)} placeholder="Owner" className="p-inputtext-sm wd-100" filter />
                </div>
              </div>

              <div className="row survey-form">
                <div className="data-responsive">
                  <DataTable value={tableData} paginator rows={5} rowsPerPageOptions={[5, 10, 20]} tableStyle={{ minWidth: "2000px" }} scrollable scrollHeight="400px" filters={filters} filterDisplay="row" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}">
                    <Column field="siteLocation" header="Site location" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="startDate" header="Start date" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="endDate" header="End date" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="transmissionMode" header="Transmission mode" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="energySource" header="Energy source" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="contractInstrumentType" header="Contract instrument type" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="supplier" header="Supplier" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="electricityConsumption" header="Electricity consumption (MWh)" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="emissionFactorType" header="Emission factor type" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="emissionsFactor" header="Emissions factor (kgCO2e/kWh)" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="locationEmissions" header="Location emissions (tCO2eq)" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="marketEmissions" header="Market emissions (tCO2eq)" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="unitCost" header="Unit cost" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="owner" header="Owner" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="reportPeriod" header="Report period" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                    <Column field="latestRefresh" header="Latest refresh" sortable filter filterPlaceholder="Filter" style={{ width: "180px" }} />
                  </DataTable>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportHistory1;
